(function () {
  // Products Mega Menu
  const megaMenuTrigger = document.querySelector("[data-meganav-products]");
  const megaMenuWrapper = document.querySelector(".mega-nav-products-wrapper");

  if (megaMenuTrigger) {
    megaMenuTrigger.addEventListener("mouseover", () => {
      megaMenuWrapper.classList.add("active");
      const productImages = megaMenuWrapper.querySelectorAll(
        ".mega-nav-products__product img",
      );
      productImages.forEach((image) =>
        image.setAttribute("src", image.dataset.src),
      );
    });

    megaMenuTrigger.addEventListener("mouseout", () => {
      megaMenuWrapper.classList.remove("active");
    });
  }

  const megaMenuItemsTriggers = document.querySelectorAll(
    ".mega-nav-products__menu-item a",
  );
  megaMenuItemsTriggers.forEach((trigger) => {
    trigger.addEventListener("mouseover", function () {
      megaMenuItemsTriggers.forEach((menuTrigger) =>
        menuTrigger.classList.remove("active"),
      );
      this.classList.add("active");
      const id = this.dataset.id;
      const productsList = document.querySelectorAll(
        ".mega-nav-products__category-wrapper > li",
      );
      const matchedProductsList = document.querySelector(
        `.mega-nav-products__category-wrapper > li[data-id="${id}"]`,
      );

      productsList.forEach((productList) =>
        productList.classList.remove("active"),
      );
      matchedProductsList.classList.add("active");
    });
  });

  // Testimonial slider
  const renderTestimonialsSlider = () => {
    const testimonialItemsWrapper = document.querySelector(
      ".testimonials__items",
    );
    if (testimonialItemsWrapper) {
      import(flu.chunks.flickity).then(({ Flickity }) => {
        new Flickity(testimonialItemsWrapper, {
          wrapAround: true,
          pageDots: false,
        });
      });
    }
  };

  renderTestimonialsSlider();

  // Cart page custom logic
  if (Shopify.CartType && Shopify.CartType === "cart_page") {
    const quantityInputs = document.querySelectorAll('input[name="updates[]"]');
    const quantityBtns = document.querySelectorAll(
      ".product-qty-selector-button",
    );
    const onQuantityUpdate = () => {
      const cartLoadingOverlay = document.querySelector(".cart__loading");
      const cartForm = document.querySelector('form[action="/cart"]');
      cartLoadingOverlay.classList.add("active");
      setTimeout(() => {
        cartForm.submit();
      }, 500);
    };

    quantityInputs.forEach((input) => {
      input.addEventListener("change", onQuantityUpdate);
    });
    quantityBtns.forEach((quantityBtn) => {
      quantityBtn.addEventListener("click", onQuantityUpdate);
    });
  }

  const attachCollapsiblesEvents = () => {
    const collapsiblesSections = document.querySelectorAll(
      ".collapsibles-wrapper",
    );
    if (collapsiblesSections) {
      collapsiblesSections.forEach((collapsiblesSection) => {
        const collapsibles =
          collapsiblesSection.querySelectorAll(".collapsible");
        collapsibles.forEach((collapsible) => {
          const collapsibleTrigger = collapsible.querySelector(
            ".collapsible__title",
          );

          collapsibleTrigger.addEventListener("click", () => {
            collapsible.classList.toggle("active");
          });
        });
      });
    }
  };

  // Collapsibles section
  attachCollapsiblesEvents();

  // Header mobile drawer
  const wholesaleResourcesTrigger = document.querySelector(
    ".drawer-menu__wholesale-resources",
  );
  if (wholesaleResourcesTrigger) {
    wholesaleResourcesTrigger.addEventListener("click", (event) => {
      event.preventDefault();
      const wholesaleMenu = document.querySelector(
        ".drawer-menu__wholesale-menu",
      );
      const wholesaleMenuWrapper = wholesaleMenu.closest(".drawer-menu__item");
      wholesaleMenuWrapper.classList.toggle("active");
    });
  }

  // Files table section
  const addFilterTablesEvents = () => {
    const filesTableSections = document.querySelectorAll(".files-table");
    if (filesTableSections) {
      filesTableSections.forEach((filesTableSection) => {
        const filterWrapper = filesTableSection.querySelector(
          ".filter-table__filter",
        );
        if (filterWrapper) {
          // Reset buttons
          const resetFilterValues = (wrapper) => {
            const checkboxes = wrapper.querySelectorAll(
              ".filter-table__values-input",
            );
            checkboxes.forEach((checkbox) => {
              checkbox.checked = false;
              const changeEvent = new Event("change");
              checkbox.dispatchEvent(changeEvent);
            });
          };
          const resetButtons = filesTableSection.querySelectorAll(
            ".filter-table__values__reset",
          );
          resetButtons.forEach((resetButton) => {
            const filterValuesWrapper = resetButton.closest(
              ".filter-table__values-wrapper",
            );
            resetButton.addEventListener("click", () =>
              resetFilterValues(filterValuesWrapper),
            );
          });

          const updateTotalCount = () => {
            const totalCount = filesTableSection.querySelector("[data-count]");
            const visibleTableRows = Array.from(
              filesTableSection.querySelectorAll(".table__row:not(.hide)"),
            );
            totalCount.innerText = visibleTableRows.length;
            const table = filesTableSection.querySelector(".table");
            const noResultsText = filesTableSection.querySelector(
              ".filter-table__no-results",
            );

            if (visibleTableRows.length === 0) {
              table.classList.add("hide");
              noResultsText.classList.add("active");
            } else {
              table.classList.remove("hide");
              noResultsText.classList.remove("active");
            }
          };

          const updateFilterValuesCount = () => {
            const checkboxes = filesTableSection.querySelectorAll(
              ".filter-table__values-input",
            );
            checkboxes.forEach((checkbox) => {
              const id = checkbox.dataset.id;
              const matchedRows = Array.from(
                filesTableSection.querySelectorAll(
                  `.table__row[data-category="${id}"]:not(.hide)`,
                ),
              );
              const valueContent = checkbox.closest(
                ".filter-table__values-item-content",
              );
              const countValueElement =
                valueContent.querySelector("[data-value-count]");
              countValueElement.innerText = `(${matchedRows.length})`;
              valueContent.dataset.valuesCount = matchedRows.length;

              if (matchedRows.length === 0) {
                checkbox.disabled = true;
              } else {
                checkbox.disabled = false;
              }
            });
          };

          const activeFilters = [];
          let searchTerm = "";
          // Filter actions
          const toggleFilters = (checkbox) => {
            let isChecked;
            let id;
            if (checkbox) {
              isChecked = checkbox.checked;
              id = checkbox.dataset.id;
              if (isChecked) {
                activeFilters.push(id);
              } else {
                const matchedElementIndex = activeFilters.findIndex(
                  (filter) => filter === id,
                );
                activeFilters.splice(matchedElementIndex, 1);
              }
            }
            const tableRows = Array.from(
              document.querySelectorAll(".table__row"),
            );
            tableRows.forEach((tableRow) => {
              const id = tableRow.dataset.category;
              if (activeFilters.length === 0) {
                tableRow.classList.remove("hide");
              } else if (activeFilters.includes(id)) {
                tableRow.classList.remove("hide");
              } else {
                tableRow.classList.add("hide");
              }
            });

            // Update based on search
            const searchableTableRows = tableRows.filter(
              (tableRow) => tableRow.classList.contains("hide") === false,
            );
            searchableTableRows.forEach((tableRow) => {
              const title = tableRow.dataset.title;
              if (searchTerm.length > 0) {
                if (title.includes(searchTerm)) {
                  tableRow.classList.remove("hide");
                } else {
                  tableRow.classList.add("hide");
                }
              }
            });
            updateTotalCount();
          };

          const checkboxes = filesTableSection.querySelectorAll(
            ".filter-table__values-input",
          );
          checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", function () {
              const checkedCheckboxes = Array.from(
                filesTableSection.querySelectorAll(
                  ".filter-table__values-input:checked",
                ),
              );
              const selectedValuesLabel = filesTableSection.querySelector(
                ".filter-table__values-selected",
              );
              selectedValuesLabel.innerText = `${checkedCheckboxes.length} selected`;
              toggleFilters(this);
              updateFilterValuesCount();
            });
          });

          const searchInput = filesTableSection.querySelector(
            'input[name="filter-table-search"]',
          );
          searchInput.addEventListener("input", (event) => {
            const term = event.target.value.toLowerCase();
            searchTerm = term;
            toggleFilters();
            updateFilterValuesCount();
          });
          updateFilterValuesCount();
          const closeBtns = filesTableSection.querySelectorAll(
            "[data-filter-close-btn]",
          );
          closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener("click", (event) => {
              event.stopPropagation();
              const valuesWrapper = closeBtn.closest(
                ".filter-table__values-wrapper",
              );
              valuesWrapper.classList.add("hide");
            });
          });
          const filterTiggers = filesTableSection.querySelectorAll(
            ".filter-table__category-btn",
          );
          filterTiggers.forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
              event.stopPropagation();
              const valuesWrapper = trigger.querySelector(
                ".filter-table__values-wrapper",
              );
              valuesWrapper.classList.remove("hide");
            });
          });
        }
      });
    }
  };
  addFilterTablesEvents();

  // Registration form
  const registerForm = document.getElementById("RegisterForm");
  if (registerForm) {
    const userTypesRadios = registerForm.querySelectorAll(
      'input[name="customer[type]"]',
    );
    let redirectUrl = "/account";
    const redirectInput = registerForm.querySelector('input[name="return_to"]');
    userTypesRadios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
          redirectUrl = event.target.dataset.redirect;
          if (redirectUrl) {
            redirectInput.value = redirectUrl;
          }
        }
      });
    });

    // Remove redirect input if not all the data is filled in
    registerForm.addEventListener("submit", () => {
      const emailInput = registerForm.querySelector(
        'input[name="customer[email]"]',
      );
      const passwordInput = registerForm.querySelector(
        'input[name="customer[password]"]',
      );

      if (emailInput.value === "" && passwordInput.value === "") {
        redirectInput.remove();
      } else {
        sessionStorage.setItem("user_type_redirect", redirectUrl);
      }
    });
  }

  const isChallengePage = () => {
    const path = window.location.pathname.toLowerCase();
    return path.endsWith("/challenge");
  };

  if (isChallengePage()) {
    sessionStorage.setItem("visited_challenge_page", "true");
  }

  const visitedChallengePage = sessionStorage.getItem("visited_challenge_page");
  if (visitedChallengePage && !isChallengePage()) {
    sessionStorage.removeItem("visited_challenge_page");
    window.location.replace(sessionStorage.getItem("user_type_redirect"));
  }

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      renderTestimonialsSlider();
      attachCollapsiblesEvents();
      addFilterTablesEvents();
    });
    document.addEventListener("shopify:section:unload", () => {
      renderTestimonialsSlider();
    });
    document.addEventListener("shopify:section:select", () => {
      renderTestimonialsSlider();
    });
    document.addEventListener("shopify:section:deselect", () => {
      renderTestimonialsSlider();
    });
    document.addEventListener("shopify:section:reorder", () => {
      renderTestimonialsSlider();
    });
  }
})();

(function () {
  const GOOGLE_SHEET_ENDPOINT = "https://script.google.com/macros/s/AKfycbxgVS6M_V46aM3-XDk9im3xyEyxApsEwADr_jIyi7A7ICnV0Sh_IVuLkY2aogmSg-um/exec";

  function trackDownloadClick(link) {
    const params = new URLSearchParams({
      button: link.textContent.trim(),
      url: link.dataset.href || link.href,
      page: window.location.href,
    });

    const pixel = new Image();
    pixel.src = `${GOOGLE_SHEET_ENDPOINT}?${params.toString()}`;
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest(".featured-columns .btn");
    if (!link) return;
    trackDownloadClick(link);
  });
})();